import { Button, IconButton, Tooltip, Box } from "@mui/material";
import React, { useMemo, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { EditOutlined } from "@mui/icons-material";
import { useGlobalFilter, useSortBy, useTable } from "react-table";
import { GlobalFilter } from "../../../components/GlobalFilter/GlobalFilter";
import { useLists } from "../../../context/listContext";
import { AntSwitch } from "../../../styles/index.sty";
import { useAuth } from "../../../context/authContext";
// import { toggleAttributeData } from '../../../api/attributes.api';
import PuffLoader from "react-spinners/PuffLoader";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

export const Finish = () => {
  const navigate = useNavigate();
  const { config } = useAuth();
  const { finishList, fetchFinishesList } = useLists();
  const data = useMemo(() => finishList, [finishList]);

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetchFinishesList();
  }, []);

  useEffect(() => {
    if (finishList.length > 0) {
      setLoading(false);
    }
  }, [finishList]);

  const columns = useMemo(
    () => [
      {
        Header: "Finish Name",
        accessor: "finish_name",
      },
    ],
    []
  );

  const tableHooks = (hooks) => {
    hooks?.visibleColumns?.push((columns) => [
      ...columns,
      {
        id: "ACTIONS",
        Header: "Actions",
        Cell: ({ row }) => {
          return (
            <div className="flex justify-center">
              <Tooltip
                title="edit"
                onClick={() => {
                  // console.log(row.id)
                  navigate("/update-finish", {
                    state: {
                      data: row.original,
                    },
                  });
                }}
              >
                <IconButton>
                  <EditOutlined
                    style={{ fontSize: "2rem", color: "#0a305e" }}
                  />
                </IconButton>
              </Tooltip>
              {/* <Tooltip
              title={`${row.is_active ? "active" : "in-active"}`}
              onClick={() =>
                toggleAttributeData(
                  { finish_id: row.original.finish_id },
                  config,
                  fetchFinishesList
                )
              }
            >
              <IconButton>
                {" "}
                <AntSwitch
                  checked={row.original.is_active ? true : false}
                  inputProps={{ "aria-label": "ant design" }}
                />
              </IconButton>
            </Tooltip> */}
            </div>
          );
        },
      },
    ]);
  };

  const tableInstance = useTable(
    { columns, data },
    useGlobalFilter,
    tableHooks,
    useSortBy
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    preGlobalFilteredRows,
    setGlobalFilter,
    state,
  } = tableInstance;

  return (
    <>
      {loading ? (
        <Box sx={style}>
          <PuffLoader loading={loading} size={150} />
        </Box>
      ) : (
        <>
          <div className="flex justify-between w-[95%] m-auto  mt-[5rem]">
            <GlobalFilter
              preGlobalFilteredRows={preGlobalFilteredRows}
              setGlobalFilter={setGlobalFilter}
              globalFilter={state.globalFilter}
            />
            <Button
              type="button"
              variant="contained"
              // onClick={handleOpen}
              onClick={() => navigate("/add-finish")}
            >
              Add New
            </Button>
          </div>
          <table {...getTableProps()} className="w-[95%] m-auto mt-10">
            <thead>
              {
                // Loop over the header rows
                headerGroups.map((headerGroup) => (
                  // Apply the header row props
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {
                      // Loop over the headers in each row
                      headerGroup.headers.map((column) => (
                        // Apply the header cell props
                        <th
                          {...column.getHeaderProps()}
                          className="border-4 p-3 bg-[#1976d2] text-white"
                        >
                          {
                            // Render the header
                            column.render("Header")
                          }
                        </th>
                      ))
                    }
                  </tr>
                ))
              }
            </thead>
            {/* Apply the table body props */}
            <tbody {...getTableBodyProps()}>
              {
                // Loop over the table rows
                rows.map((row, index) => {
                  // Prepare the row for display
                  prepareRow(row);
                  return (
                    // Apply the row props
                    <tr {...row.getRowProps()}>
                      {
                        // Loop over the rows cells
                        row.cells.map((cell) => {
                          // Apply the cell props
                          return (
                            //  <td {...cell.getCellProps()} className={`p-5 border-1px bg-blue-300 cursor-pointer`}>
                            <td
                              {...cell.getCellProps()}
                              className={`p-5 border-1px bg-${
                                index % 2 === 0 ? "white" : "blue-300"
                              } cursor-pointer text-center`}
                              style={{
                                background: !row.original.is_active
                                  ? "#b3b3b3"
                                  : null,
                              }}
                            >
                              {
                                // Render the cell contents
                                cell.render("Cell")
                              }
                            </td>
                          );
                        })
                      }
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </>
      )}
    </>
  );
};
